export default __webpack_public_path__ + "static/media/Conscript's Gauntlets of the Eastern Sun.575c17d7.jpg";